import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();

export function getOrigin() {
	const { origin, protocol, hostname, port } = window.location;
	return origin || protocol + '//' + hostname + (port ? ':' + port : '');
}
